import { openAccountGator } from "@credeau/accountgator";
import { REACT_APP_CREDEAU_AUTH_TOKEN as CREDEAU_AUTH_TOKEN } from "../utils/environment";

const { protocol, host } = window.location;

export const CREDEAU_CONSENT_TEMPLATES = ["BANK_STATEMENT_PERIODIC", "BANK_STATEMENT_ONETIME"];

export const parseConsentHandlesStatus = (value) => {
  if (!value) return null;
  if (typeof value === "object") return Array.isArray(value) ? null : value;

  try {
    const parsedValue = JSON.parse(value);
    return parsedValue && typeof parsedValue === "object" && !Array.isArray(parsedValue) ? parsedValue : null;
  } catch {
    return null;
  }
};

export const openCredeauAccountGator = async ({
  customerId,
  redirect_url = `${protocol}//${host}/finbox`,
  mobile,
}) => {
  try {
    const params = {
      client_id: "ram_fincorp",
      user_id: `${customerId}`,
      auth_token: CREDEAU_AUTH_TOKEN,
      redirect_url,
      is_redirecting: !!redirect_url,
      consent_templates: CREDEAU_CONSENT_TEMPLATES,
      mobile_number: String(mobile),
    };
    return await openAccountGator(params);
  } catch (error) {
    console.error("Credeau AccountGator Error:", error);
    alert("Credeau SDK Error: " + (error?.message || JSON.stringify(error)));
    window.location.href = `${protocol}//${host}/loan-reject`;
  }
};
